import { render } from "./NoteListPro.vue?vue&type=template&id=3648f12a&scoped=true"
import script from "./NoteListPro.vue?vue&type=script&lang=js"
export * from "./NoteListPro.vue?vue&type=script&lang=js"

import "./NoteListPro.vue?vue&type=style&index=0&id=3648f12a&lang=css"
import "./NoteListPro.vue?vue&type=style&index=1&id=3648f12a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3648f12a"]])

export default __exports__